import React,{Component} from 'react';
import { Card, CardImg, CardText, CardBody, 
  CardTitle, CardSubtitle,Button } from 'reactstrap';
import '../stylesheets/basicContent.css';
import { withRouter } from 'react-router-dom';

class BasicContent extends Component  {

  constructor(props){
    super(props);
    this.state = {
      message:'',
      messageHeader:'',
      display:false,
    }

    this.displayMessage = this.displayMessage.bind(this);
    this.registerNow=this.registerNow.bind(this);
  }

  registerNow(event){
    console.log(this.props);
    const { history } = this.props;
    if(history) history.push('/static/auth/SignIn');
  }

  displayMessage(event,type) {
    
    switch(type) {
      case 'behindTheWheel': 
      this.setState({
        messageHeader:'Behind the Wheel Info',
        message:"We provide 2 Hours behind the wheel private training  which are structured to meet the individual needs of the student. "+
                "Our Instructors constantly analyze each students progress and make adjustments to make the student confident and a better driver "+
        "Instructors are fully state licensed and trained to work with all drivers regardless of their prior driving experience. "+
          "Click register now and start your training",
          urls:[],
        display:true,
        mediaImage:'https://img.icons8.com/plasticine/100/000000/car.png'
      });
      break;
      case 'driverEduCourse':
        this.setState({
        messageHeader:'Online Drivers Education Course',
        message:"Joshua's Law is a Georgia state law enacted in 2007 changing the driver's license requirements for teen drivers. A teen driver must meet the new requirements to obtain a Georgia driver's license "+
                "We provide 30 hours online training and 6 hours behind the wheel to make the student eligible to obtain the license. Click register now and start your training",
        urls:["Georgia Teen Drivers Ed — http://go.aceable.com/aff_c?offer_id=9&aff_id=8007",
              "Defensive Driving — http://go.idrivesafely.com/aff_c?offer_id=21&aff_id=8007",
              "Georgia Permit Test Prep Course — http://go.aceable.com/aff_c?offer_id=76&aff_id=8007"],
        display:true,
        mediaImage:'https://img.icons8.com/ios/100/000000/happy-cloud.png'
      });
      break;
      case 'roadTest':
        this.setState({
          messageHeader:'Final Road Test',
          message:"Georgia Road Test tests the ability of a candidate based on various parameters. This takes about 20-35 minutes. "+
          "This package includes 2 hours behind the wheel training which includes the actual test track with parallel parking training "+
          "Pick-up and drop-off from a place of your choice. Documents related to the car is provided with the car which is used in our "+
          "training to boost your confidence. We also help you expedite road test appointment.  Let's get started today! Click register now!",
          urls:[],
          display:true,
          mediaImage:'https://img.icons8.com/officel/80/000000/driver.png'
        });
        break;
      default: 
      break;
    }
  } 

  hideMessage(event) {
    this.setState({
      messageHeader:'',
      message:'',
      urls:[],
      display:false
    });
  }

  componentDidMount() {
    // Display driverEduCourse by default when component mounts
    this.displayMessage(null, 'driverEduCourse');
  }


  render(){

    const toastShow = () => {
      if (this.state.display) { 
        return (
          <div className="card toast-message">
            <div class="card-header">
              <h4>{this.state.messageHeader}</h4>
            </div>
            <div className="card-body">
              <p className="card-text">{this.state.message}</p>
              <br />
              <br />
              <div className="card-links">
                {this.state.urls.map((url, index) => {
                  const dashIndex = url.indexOf('—');
                  if (dashIndex !== -1) {
                    const description = url.substring(0, dashIndex).trim();
                    const actualUrl = url.substring(dashIndex + 1).trim();
                    return (
                      <p key={index}>
                        <a href={actualUrl} target="_blank" rel="noopener noreferrer" className="btn btn-link">
                          {description}
                        </a>
                      </p>
                    );
                  }
                  return <p key={index}>{url}</p>;
                })}
              </div>
              <button 
                onClick={(event) => this.hideMessage(event)} 
                className="btn btn-info"
              >
                Hide
              </button>
            </div>
          </div>
        );
      } else {
        return '';
      }
    };

    return(
      <div className="basic-content-container">
        <div className="row">
          <div className="col-sm-4">
          <Card className='card-shadow'>
            <div className="w-100">
              <CardImg top width="50%" src="https://img.icons8.com/plasticine/100/000000/car.png" alt="Card image cap" />
            </div>
            <CardBody>
              <CardTitle><h3>Behind the Wheel Lessons</h3></CardTitle>
              <CardSubtitle></CardSubtitle>
              <CardText>1-on-1 Behind the wheel instruction. Fully licensed
                instructors. Student pick-up/drop off included.</CardText>
              <Button color="success" onClick={this.registerNow}>Register Now</Button>
              <span>  </span>
              <Button onClick={(event) => this.displayMessage(event,'behindTheWheel')} color="danger">Learn More</Button>
            </CardBody>
          </Card>

          </div>
          <div className="col-sm-4">
          <Card className='card-shadow'>
            <div className="w-100">
              <CardImg top width="100%" src="https://img.icons8.com/ios/100/000000/happy-cloud.png" alt="Card image cap" />
            </div>
            <CardBody>
              <CardTitle><h3>Online Drivers Education Course</h3></CardTitle>
              <CardSubtitle></CardSubtitle>
              <CardText>Complete at your own pace & convenience. DDS approved.
                Meets Joshua’s Law requirement.</CardText>
                <span>  </span>
              <Button onClick={(event) => this.displayMessage(event,'driverEduCourse')} color="danger">Learn More</Button>
            </CardBody>
          </Card>

          </div>
          <div className="col-sm-4">
          <Card className='card-shadow'>
            <div className="w-100">
              <CardImg top src="https://img.icons8.com/officel/80/000000/driver.png" alt="Card image cap" />
            </div>
            <CardBody>
              <CardTitle><h3>Road Test</h3></CardTitle>
              <CardSubtitle></CardSubtitle>
              <CardText>Refresher course before Road Test on actual test track.
                This package includes free pick and drop along with reduced wait time for getting a test appointment.
              </CardText>
              <Button color="success" onClick={this.registerNow}>Register Now</Button>
              <span>  </span>
              <Button onClick={(event) => this.displayMessage(event,'roadTest')} color="danger">Learn More</Button>
            </CardBody>
          </Card>

          </div>
    </div>
    <br/>
    <br/>
    <div className="row">
      <div className="col-sm-4"></div>
      <div className="col-sm-4">
      {toastShow()}
      </div>
      <div className="col-sm-4"></div>
    </div>
    </div>
  );
  }

}

export default  withRouter(BasicContent);
